import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ToTimeJalali } from "../../../Common/Function";
import Loading from "../../../Common/Components/Loading";
import { GetTicket, FormChatSubmit } from "./Components/Services";
import { useLocation } from "react-router-dom";
function Chating() {
  const { id } = useParams();
  const User = useSelector(state => state.user);
  const location = useLocation();
  const initialState = {
    loading: true,
    loadbtn: false,
    usertiketer: location.state.data && location.state.data.usertiketer,
    data: {
      data: null,
      current_page: null,
    },
    form: {
      ticket_id: id,
      description: "",
      attach: null,
    },
  };
  const [state, setState] = useState(initialState);

  const Handler = () => {
    setState({ ...state, loading: true });
    GetTicket(id).then(result => {
      setState({
        ...state,
        loading: false,
        data: result,
      });
    });
  };

  useEffect(() => {
    Handler();
  }, []);
  const SendMessage = () => {
    setState({ ...state, loadbtn: true });
    FormChatSubmit(state.form).then(res => {
      if (res) {
        setState({
          ...state,
          form: { ...state.form, description: "", attach: null },
          data: res,
          loadbtn: false,
        });
      } else {
        setState({ ...state, loadbtn: false });
      }
    });
  };
  function MeChat({ data }) {
    return (
      <div
        className={`col-10`}
        style={
          data.type == "answer"
            ? { marginLeft: "auto" }
            : { marginRight: "auto" }
        }
      >
        <div
          className="card"
          style={{ borderRadius: 10, boxShadow: "1px 1px 6px #ccc" }}
        >
          <div className="card-body">
            <div className="entete">
              <h5>
                {data.type == "answer"
                  ? User.fullname
                  : state.usertiketer && state.usertiketer.fullname}
              </h5>
              <small>{ToTimeJalali(data.created_at)}</small>
            </div>
            <h6>{data.message}</h6>
          </div>
        </div>
      </div>
    );
  }
  return (
    <Fragment>
      <div className="card">
        <div className="card-body">
          <h2 className="my-2">صفحه چت</h2>
          {state.loading ? (
            <Loading count={1} col={12} height={600} />
          ) : (
            <>
              <h4>{}</h4>
              {state.data &&
                state.data.messages.map((messages, i) => {
                  return <MeChat data={messages} key={i} />;
                })}
              <div
                className="row mt-4 pt-4 align-items-end"
                style={{ borderTop: "2px solid", borderTopColor: "#ccc" }}
              >
                <div className="form-group col-11 mb-0">
                  <label htmlFor="message">ارسال پیام جدید</label>
                  <input
                    id="message"
                    placeholder="توضیحات شما ..."
                    value={state.form && state.form.description}
                    onChange={e =>
                      setState({
                        ...state,
                        form: { ...state.form, description: e.target.value },
                      })
                    }
                    className=" form-control"
                  />
                </div>
                <div className="col-1">
                  <button
                    disabled={state.loadbtn}
                    onClick={() => SendMessage()}
                    type="button"
                    class="btn btn-success "
                  >
                    {state.loadbtn ? "درحال ارسال" : "ارسال"}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </Fragment>
  );
}

export default Chating;
